import { useContext } from 'react';
import CustomerContext, { CustomerContextType } from './CustomerContext';

const useCustomerContext = (): CustomerContextType => {
  const context = useContext(CustomerContext);
  if (!context) {
    console.warn(
      'useCustomerContext should be used within a CustomerContextProvider, or you will get any results for `customerName` and `tenantId`',
    );
    return {
      tenantId: '',
    };
  }
  return context;
};

export default useCustomerContext;
